// extracted by mini-css-extract-plugin
export var typingIndicator = "_qr-0";